import { ComponentPortal } from "@angular/cdk/portal";
import { ToastComponent } from "../components/toast/toast.component";
import { Overlay, OverlayConfig, OverlayRef } from "@angular/cdk/overlay";
import { ComponentRef, Injectable } from "@angular/core";

/**
 * PURPOSE:responsible for setting the toast component data and opening the toast component
 */
@Injectable({
  providedIn: "root"
})
export class ToastService {
  private readonly TOAST_DURATION: number = 7000; // Default duration

  constructor(private overlay: Overlay) {}

  open(
    message: string,
    action: string = "Close",
    config: {
      duration: number;
      panelClass?: string[];
    } = {
      duration: this.TOAST_DURATION,
      panelClass: []
    }
  ): OverlayRef {
    const overlayConfig = new OverlayConfig();
    const overlayRef: OverlayRef = this.overlay.create(overlayConfig);
    const toastPortal = new ComponentPortal(ToastComponent);
    const toastRef: ComponentRef<ToastComponent> = overlayRef.attach(toastPortal);

    toastRef.instance.data = {
      message,
      action,
      panelClass: config.panelClass,
      duration: config.duration
    };

    // Set overlayRef to component for disposal
    toastRef.instance.setOverlayRef(overlayRef);

    // Auto dismiss after duration
    if (config.duration > 0) {
      setTimeout((): void => {
        overlayRef.dispose();
      }, config.duration);
    }

    return overlayRef;
  }
}
